import axios from 'axios';
import { configRefs } from '@utils/constants';

async function deleteNotificationRequest(notification) {
  if ((await configRefs.env.node.get()) !== "production") {
    console.warn("deleteNotificationRequest(): notification not deleted due to NODE_ENV");
    return;
  }
  await axios.post(`${await configRefs.apis.userdata.get()}/api/Notifications/${notification.id}/MarkAsRead`, {
    empty: true
  });
}

export { deleteNotificationRequest };
//# sourceMappingURL=api.delete-notification.request.js.map
